// extracted by mini-css-extract-plugin
module.exports = {"savedOrders":"SavedOrders_savedOrders__3pr_M","hidden":"SavedOrders_hidden__14RM0"};